/* =============================================================================
   assets/custom-announcement.js
   -----------------------------------------------------------------------------
   Rotator behaviour for sections/announcement-bar.liquid. Only loaded on
   pages where there are 2+ announcement messages (see the section file) --
   with a single message there's nothing to rotate, so no JS is requested
   at all in that case.

   Progressive enhancement: the first message is already visible from the
   server-rendered markup, so if this script fails to load for any reason,
   visitors still see one working message, just without the rotation.
============================================================================= */
(function () {
  'use strict';

  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  var slides = bar.querySelectorAll('[data-announcement-slide]');
  var dots = bar.querySelectorAll('[data-announcement-dot]');
  if (slides.length < 2) return;

  var autoRotate = bar.getAttribute('data-auto-rotate') === 'true';
  var speedSeconds = parseInt(bar.getAttribute('data-speed'), 10) || 5;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var currentIndex = 0;
  var timerId = null;

  function showSlide(index) {
    for (var i = 0; i < slides.length; i++) {
      var isActive = i === index;
      slides[i].classList.toggle('is-active', isActive);
      if (isActive) {
        slides[i].removeAttribute('aria-hidden');
      } else {
        slides[i].setAttribute('aria-hidden', 'true');
      }
    }
    for (var d = 0; d < dots.length; d++) {
      dots[d].classList.toggle('is-active', d === index);
    }
    currentIndex = index;
  }

  function nextSlide() {
    showSlide((currentIndex + 1) % slides.length);
  }

  function startTimer() {
    if (!autoRotate || reduceMotion) return;
    stopTimer();
    timerId = window.setInterval(nextSlide, speedSeconds * 1000);
  }

  function stopTimer() {
    if (timerId) {
      window.clearInterval(timerId);
      timerId = null;
    }
  }

  for (var j = 0; j < dots.length; j++) {
    (function (index) {
      dots[index].addEventListener('click', function () {
        showSlide(index);
        startTimer();
      });
    })(j);
  }

  bar.addEventListener('mouseenter', stopTimer);
  bar.addEventListener('mouseleave', startTimer);
  bar.addEventListener('focusin', stopTimer);
  bar.addEventListener('focusout', startTimer);

  startTimer();
})();
